import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function SimpleSpinner(props) {
  const { children, className, spinnerAnimationStyle, spinnerAnimationClassName } = props;

  return (
    <div
      data-testid="spinner"
      role="status"
      aria-label="loading content"
      aria-hidden="false"
      className={classnames('rx-loader--container', className)}>
      {children}
      <div className={classnames('spinner-animation', spinnerAnimationClassName)} style={spinnerAnimationStyle} />
    </div>
  );
}

SimpleSpinner.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  spinnerAnimationStyle: PropTypes.object,
  spinnerAnimationClassName: PropTypes.string,
};
